import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";



export function gustoApi() {

    const callApi = useApiCall();

    const gustoFetchClientId = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.FETCH_CLIENTID, data, onSuccess, onError);
    }
    const gustoCallback = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.CALLBACK, data, onSuccess, onError);
    }
    const gustoImportData = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.IMPORT_DATA, data, onSuccess, onError);
    }
    const gustoFetchEarningTypes = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.FETCH_EARNING_TYPES, data, onSuccess, onError);
    }
    const gustoPostEarningClassification = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.POST_EARNING_TYPES, data, onSuccess, onError);
    }
    const gustoFetchPayrollJournal = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.FETCH_PAYROLL_JOURNAL_LIST, data, onSuccess, onError);
    }
    const gustoFetchPayrollDetails = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.FETCH_PAYROLL_JOURNAL_DETAILS, data, onSuccess, onError);
    }
    const gustoVerifyAndSubmitJournal = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.GUSTO.VERIFY_AND_SUBMIT_JOURNAL, data, onSuccess, onError);
    }

    return {
        gustoFetchClientId,
        gustoCallback,
        gustoImportData,
        gustoFetchEarningTypes,
        gustoPostEarningClassification,
        gustoFetchPayrollJournal,
        gustoFetchPayrollDetails,
        gustoVerifyAndSubmitJournal
    }
}